module.exports = __webpack_public_path__ + "static/media/onebedroom.aaf8c460.png";